import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { FaArrowLeft } from "react-icons/fa";
import React from "react";

export default function CdrReadySidebarStepDisplay() {

  return (
      <VStack h="100vh" justifyContent="space-between" position="relative">
        <Box w={"450px"} mt={"40px"} ml={"65px"}>
          <Text
            color={"white"}
            fontWeight={"semibold"}
            fontSize={"1.4em"}
            mb={6}
          >
            Steps
          </Text>
          {/*----------- First Step ------------*/}
          <HStack spacing={5} mb={8}>
            <Box>
              <Box
                borderRadius={"50%"}
                w={"40px"}
                h={"40px"}
                color={"white"}
                bg={"#1fc296"}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Text>1</Text>
              </Box>
            </Box>
            <Box>
              <Text color={"white"} fontWeight={"semibold"} fontSize={"1.7em"}>
                Connect
              </Text>
              <Text color={"white"} fontSize={"1em"}>
                Provide your details to us to enable our service.
              </Text>
            </Box>
          </HStack>

          {/*----------- Second Step ------------*/}
          <HStack
            spacing={5}
            mb={8}
            sx={{
              position: "relative",
              "::before": {
                content: '""',
                position: "absolute",
                bottom: 16,
                left: 5,
                height: "75%",
                borderLeft: "2px dotted",
                borderColor: "#1fc296",
              },
            }}
          >
            <Box>
              <Box
                borderRadius={"50%"}
                w={"40px"}
                h={"40px"}
                color={"white"}
                bg={"#1fc296"}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Text>2</Text>
              </Box>
            </Box>
            <Box>
              <Text color={"white"} fontWeight={"semibold"} fontSize={"1.7em"}>
                Consent
              </Text>
              <Text color={"white"} fontSize={"1em"}>
                Give us permission to securely connect with your bank and see
                your accounts.
              </Text>
            </Box>
          </HStack>

          {/*----------- Third Step ------------*/}
          <HStack
            opacity={"45%"}
            spacing={5}
            mb={8}
            sx={{
              position: "relative",
              "::before": {
                content: '""',
                position: "absolute",
                bottom: 16,
                left: 5,
                height: "90%",
                borderLeft: "2px dotted",
                borderColor: "#1fc296",
              },
            }}
          >
            <Box>
              <Box
                borderRadius={"50%"}
                w={"40px"}
                h={"40px"}
                color={"white"}
                bg={"#1fc296"}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Text>3</Text>
              </Box>
            </Box>
            <Box>
              <Text color={"white"} fontWeight={"semibold"} fontSize={"1.7em"}>
                Confirm
              </Text>
              <Text color={"white"} fontSize={"1em"}>
                Check that all the accounts you want to share are available
                through CDR.
              </Text>
            </Box>
          </HStack>
        </Box>
      </VStack>
  );
}
